import React from "react";
import { reportFrontendError } from "utils/errorMonitoring";

class FrontendErrorBoundary extends React.Component {
  componentDidCatch(error, errorInfo) {
    reportFrontendError({
      error,
      component: "ReactErrorBoundary",
      stack: errorInfo?.componentStack || error?.stack || "",
      details: {
        component_stack: errorInfo?.componentStack,
      },
    });
  }

  render() {
    return this.props.children;
  }
}

export default FrontendErrorBoundary;

